module.exports = __webpack_public_path__ + "static/banner-fdd5fad4d1b225a9d23a03b9a3be5fe8.gif";